import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_KEY = 'board/:boardId/reporting/stages/:stageId/owners/:ownerId/opportunities';

export function useOpportunityReportingOwnerOpportunitiesQuery({
	boardId,
	filterRequest,
	stageId,
	ownerId,
	pageSize = 20,
	enabled,
}: {
	boardId: string;
	filterRequest: Api.IOpportunityReportingFilterRequest;
	stageId: string;
	ownerId: string;
	pageSize?: number;
	enabled: boolean;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IOpportunityReportingOwnerOpportunitiesResponse>({
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load owner opportunities',
		},
		initialPageParam: undefined as string | undefined,
		getNextPageParam: lastPage => lastPage.pageToken || undefined,
		queryFn: ({ pageParam }) =>
			userSession.webServiceHelper.callAsync<Api.IOpportunityReportingOwnerOpportunitiesResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `board/${boardId}/reporting/stages/${stageId}/owners/${ownerId}/opportunities`,
					queryParams: { pageSize, ...(pageParam ? { pageToken: pageParam } : {}) },
				}),
				'POST',
				filterRequest
			),
		queryKey: [BASE_KEY, boardId, filterRequest, stageId, ownerId, pageSize],
		refetchOnWindowFocus: false,
	});
}
